module.exports = __webpack_public_path__ + "img/a4.7545e04a.png";